/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {initiatePayment} from '../api'

export const useMutationInitiatePayment = createReactQueryMutationHook('initiatePayment', initiatePayment)
